module.exports = __webpack_public_path__ + "img/2025-02-13d_3.9b687c01.jpg";